import React from 'react'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { MenuItem, Select } from '@mui/material'
import styles from './styles.module.css'
import { PALETTE } from '../../../../styles/constants'
import ChevronDownIconSelect from '../../../icons/ChevronDownIconSelect'

const cx = (...c) => c.filter(Boolean).join(' ')

const theme = createTheme({
  components: {
    MuiSelect: {
      styleOverrides: {
        root: {
          // update border color on focused state
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'transparent !important',
          },
          '& .Mui-selected': {
            backgroundColor: PALETTE.gray80
          },

        },
        select: {
          border: `2px solid ${PALETTE.gray80}`,
          borderRadius: '2px',
          padding: '8px 16px',
          minHeight: 'auto'
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          backgroundColor: PALETTE.white,
          '&.Mui-selected': {
            backgroundColor: PALETTE.gray20,
            '&:focus':{
              backgroundColor: PALETTE.gray20
            },
            '&:hover':{
              backgroundColor: PALETTE.gray30
            },
          },
          '&:hover':{
            backgroundColor: PALETTE.gray10
          }
        }
      }
    }
  }
})



function MySelect({ options, value, onChange }) {
  return (
    <ThemeProvider theme={theme}>
      <Select
        className={styles.select}
        value={value}
        onChange={onChange}
        IconComponent={({ className, ...props }) => (
            <div {...props} className={cx(styles.iconWrapper, className)}>
              <ChevronDownIconSelect width={24} height={24} />
            </div>
        )}
      >
        {
          options.map(o => (
            <MenuItem className={styles.menuItem} value={o._key} key={o._key}>{o.title}</MenuItem>
          ))
        }
      </Select>
    </ThemeProvider>
  )
}

export default MySelect
